import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import logsService from "../../../components/Services/logs.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/dist/rsuite.css";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import {addDays, isAfter, startOfMonth, startOfYear} from "date-fns";
import endOfMonth from "date-fns/endOfMonth";
import endOfYear from "date-fns/endOfYear";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import {
  Checkbox,
 InputLabel,
 ListItemText,
 MenuItem,
 Select,
} from "@mui/material";

const Logs = ({ logsList,userDetails }) => {
 const [logsDownloadList, setLogsDownloadList] = useState(null);
 const isButtonEnabled = useSelector(
  (state) => state?.buttonReducer?.isButtonEnabled
 );
 const dispatch = useDispatch();
 const initialValues = {
  logOption: [],
  dateRange: "",
 };

 const validationSchema = Yup.object().shape({
    logOption: Yup.array().min(1, "Please select at least one option"),
  dateRange: Yup.array().required("Please the date range"),
 });
 const predefinedRanges = [
  {
   label: "Today",
   value: [new Date(), new Date()],
   placement: "left",
  },
  {
   label: "This week",
   value: [startOfWeek(new Date()),new Date()],
   placement: "left",
  },
  {
   label: "This month",
   value: [startOfMonth(new Date()),new Date() ],
   placement: "left",
  },
  {
   label: "This year",
   value: [startOfYear(new Date()),new Date()],
   placement: "left",
  }
 ];
 function downloadExcelFilesFromBase64(file) {
 
   // Convert base64 to binary
   const binaryString = atob(file?.fileInBytes);

   // Convert binary to ArrayBuffer
   const arrayBuffer = new ArrayBuffer(binaryString.length);
   const uint8Array = new Uint8Array(arrayBuffer);
   for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
   }

   // Create Blob from ArrayBuffer
   const blob = new Blob([uint8Array], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
   });

   // Create download link
   const downloadLink = document.createElement("a");
   downloadLink.href = URL.createObjectURL(blob);
   downloadLink.download = file.fileName || `logs.xlsx`; // Use a default name if fileName is not provided

   // Append the link to the body
   document.body.appendChild(downloadLink);

   // Trigger the click event to start the download
   downloadLink.click();

   // Remove the link from the body
   document.body.removeChild(downloadLink);
 }

 const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 250,
   },
  },
 };
 const currentDate = new Date();

const { afterToday } = DateRangePicker;

 return (
  <div>
   <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={(values) => {
     disableButton()(dispatch);
     const reqBody = {
      enumLogList: values?.logOption,
      "startDate":
       values.dateRange && moment(values.dateRange[0]).format("DD-MMM-yyyy"),
      "endDate":
       values.dateRange && moment(values.dateRange[1]).format("DD-MMM-yyyy"),
     };
     logsService
      .downloadLogsList(reqBody,userDetails?.userId)
      .then((response) => {
       if (response?.data?.code === 200) {
        toast.success(response?.data?.message, toastProperties);
        setLogsDownloadList(response?.data?.data);
        downloadExcelFilesFromBase64(response?.data?.data);
        enableButton()(dispatch);
       } else if (response?.data?.code !== 200) {
        enableButton()(dispatch);
       }
      })
      .catch((error) => {
       console.log("Api Error:", error);
       enableButton()(dispatch);
      });
    }}
   >
    {({ values, setFieldValue, setFieldTouched, setValues, submitForm }) => {
      console.log("formValues_Logs==>",{values})
     return (
      <Form>
       <div
        style={{ display: "flex", gap: "15px", padding: "10px", width: "50%" }}
       >
         <div className="dateRange-logs">
          <InputLabel id="demo-multiple-name-label">Logs Option</InputLabel>
          <Select
           labelId="demo-multiple-name-label"
           id="demo-multiple-name"
           multiple
           name="logOption"
           value={values?.logOption}
           onChange={(e) => setFieldValue("logOption", e.target.value)}
           renderValue={(selected) => {
            // Get the Names of the selected items
            const selectedUserNames = logsList
              .filter((item) => selected.includes(item?.type))
              .map((item) => item.name);
            return selectedUserNames.join(', ');
          }}
           style={{width:'100%'}}
           MenuProps={MenuProps}
          >
           {logsList?.map((item, i) => (
            <MenuItem key={i} value={item?.type}>
              <Checkbox checked={values?.logOption.indexOf(item?.type) > -1} />
              <ListItemText primary={item?.name} />
            </MenuItem>
           ))}
          </Select>
          <ErrorMessage
           name="logOption"
           className="text-danger"
           component="div"
          />
         </div>
        <div className="dateRange-logs">
         <InputLabel id="demo-multiple-name-label">Date Range</InputLabel>
         <DateRangePicker
          name="dateRange"
          format="dd-MMM-yyyy"
          character=" to "
          size="lg"
          placeholder="Select Date Range"
          showOneCalendar
          onChange={(e) => {
           setFieldValue("dateRange", e);
          }}
        //   onClean={() => submitForm()}
          className="rs-picker-custom-styles"
          value={values.dateRange}
          ranges={predefinedRanges}
          shouldDisableDate={afterToday()}
         />
         <ErrorMessage
          name="dateRange"
          className="text-danger"
          component="div"
         />
        </div>
       </div>
       <button
        type="submit"
        className="btn btn-signup btn-primary"
        disabled={isButtonEnabled}
        style={{ marginLeft: "10px" }}
       >
        Download
       </button>
      </Form>
     );
    }}
   </Formik>
  </div>
 );
};

export default Logs;
